import "core-js/modules/es.object.to-string";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getActivityConfigList, getActivityConfigDetailToId, getActivityConfigNameList } from "@/api/gmtool/packageCode";
import { gmTool } from "@/mixins/index";
import activities from "./mixins/activities";
import addfileActivities from "./components/addfileActivities";
import viewfileActivities from "./components/viewfileActivities";
export default {
  name: "fileActivities",
  mixins: [gmTool, activities],
  components: {
    addfileActivities: addfileActivities,
    viewfileActivities: viewfileActivities
  },
  data: function data() {
    return {
      tableData: [],
      reqLoading: false,
      ConfigNameList: []
    };
  },
  activated: function activated() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  created: function created() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this.getgetActivityConfigNameList();

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  methods: {
    getList: function getList(e) {
      var _this2 = this;

      this.paramsData.page = e;
      this.reqLoading = true;
      getActivityConfigList(this.paramsData).then(function (res) {
        if (res.status == 200) {
          _this2.tableData = res.data.data;
          _this2.total = res.data.total;
        }
      }).finally(function () {
        _this2.reqLoading = false;
      });
    },
    updFile: function updFile() {
      this.getgetActivityConfigNameList();
      this.getList(1);
    },
    // 获取配置列表
    getgetActivityConfigNameList: function getgetActivityConfigNameList() {
      var _this3 = this;

      getActivityConfigNameList().then(function (res) {
        if (res.status == 200) {
          _this3.ConfigNameList = res.data;
        }
      });
    },
    openView: function openView(row) {
      var _this4 = this;

      this.lodclickOperationLog('show-config', this.$t('clickViewConfigBtn'));
      getActivityConfigDetailToId({
        file: row.file,
        config_id: row.config_id,
        is_parse: 2
      }).then(function (res) {
        if (res.status == 200) {
          _this4.$refs.viewfileActivities.open(res.data.config);
        }
      });
    },
    clickup: function clickup() {
      this.$refs.addfileActivities.open();
      this.lodclickOperationLog('upload-config', this.$t('clickUploadConfigFileBtn'));
    }
  }
};